import React from 'react';

import fetch from './../fetch';

import moment from 'moment';

import utils from './../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},

    {key:'assignOrgName', label: '部门名称', width: 150},
    {key:'employeeName', label: '授权人名称'},
    {key:'employeeCode', label:'职工代码'},
    // {key:'roleName', label: '角色名称'},
    {key:'termName', label: '所属学期'}
    
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let data = {
        assignOrgId: keywords.orgId,
        // roleId: keywords.role.id,
        termId: keywords.termId,
        employeeName: keywords.realName
    }
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('graduation/course/role/query?' + params.join('&'),  data)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}



/**
 * @method insert
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
 const insert = (data) => {
    return fetch.post('graduation/course/insertAuth', data)
    .then(response => {
        if(response.code === 200) {
            message.success('温馨提示：授权人添加成功！');
        }
    });
}


/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids,roleId) => {
    return fetch.post('graduation/course/deleteAssignOrg', {"ids" : ids, "roleId" : roleId})
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

const getSelect = () => {
    return DataGrid.selections;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'listen/org'+ url;
};

const getRoleByLimits = (limits) => {
    return fetch.get(`role/bylimit/${limits}`).then(res => {
        if(res.code == 200) {
            return res.payload.data;
        }
    })
}

const getRoleById = (id) => {
    return fetch.get(`role/byId/${id}`).then(res => {
        if(res.code == 200) {
            return res.payload.data;
        }
    })
}

export default {
    querySearch,
    insert,
    remove,
    columns,
    onSelect,
    setRefresh,
    getSelect,
    redirect,
    getRoleByLimits,
    getRoleById
}